import { Controller, useFormContext } from 'react-hook-form';
import { FormControlLabel, Switch, SwitchProps } from 'ui';

type Props = SwitchProps & { name: string; label: string };

export const SwitchField = ({ name, label, ...rest }: Props) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => {
        return (
          <FormControlLabel
            label={label}
            control={
              <Switch
                {...field}
                {...rest}
                checked={Boolean(field.value)}
                onChange={(e) => {
                  rest.onChange?.(e, e.target.checked);
                  field.onChange(e.target.checked);
                }}
              />
            }
          />
        );
      }}
    />
  );
};

SwitchField.displayName = 'SwitchField';
